export const vars = {
  // PRINCIPALES
  colorPrimary: "#FFF600",
  colorPrimaryHover: "#fff70085",
  colorPrimaryLight: "#FFEDDA",
  colorPrimaryUltraLight: "#FFFDBA",

  // OTHERS
  colorOrange: "#FF9500",
  colorGreen: "#34C759",

  // NEUTROS
  colorWhite: "#ffffff",
  colorWhiteMedium: "#F4F4F4",
  colorBlack: "#000000",
  colorBlackLight: "#4A4A4A",
  colorGray: "#808080",
  colorGrayMedium: "#777777",
  colorGraySemi: "#D2D2D2",
  colorGrayLight: "#F4F4F4",

  // ESTADOS
  colorSuccess: "#10B981",
  colorWarning: "#FACC15",
  colorError: "#EF4444",
  colorInfo: "#3B82F6",

  // HEADER
  sizeHeaderHeight: "70px",

  // PADDINGS
  sizePaddingDesktop: "90px",
  sizePaddingTablet: "40px",
  sizePaddingMobile: "16px",

  // WIDTH PAGE
  sizeTablet: "720px",
  sizeMobile: "480px",
};
